import React, { useMemo, useState } from 'react';
import cn from 'classnames';
import { Link, Route, withRouter } from 'react-router-dom';
import { ActionBtnType } from '../../../../../screens/Projects/components/ActionMenu/ActionMenuItem/ActionMenuItem';
import pathToUrl from 'Shared/util/pathToUrl';

import EditAssigmentSVG from 'Components/Admin/assets/EditAssigmentSVG';
import PlusSmallSVG from 'Components/Admin/assets/PlusSmallSVG';
import ChangeSVG from 'Components/Admin/assets/ChangeSVG';

import ActionDropdown from '../../../../../screens/Projects/components/ActionDropdown';
import AppSwitch from 'Components/AppSwitch';
import AdminModal from 'Components/Admin/AdminModal/AdminModal';
import { ItemWrapper } from 'Components/Admin/Form';
import { Select } from 'Components/Admin/Form/Fields';
import formatDataForSelect from 'Shared/util/formatDataForSelect';
import Button from 'Components/Admin/Button';
import PlusSVG from 'Components/Admin/assets/PlusSVG';

const ChangeEntity = ({
                        name,
                        description,
                        fieldProps: { onChange, value, ...fieldProps },
                        options,
                        history,
                        closeUrl,
                        addNewUrl,
                        fetchOptions,
                      }) => {
  const [state, handleChange] = useState(value);

  const handleClose = () => history.push(closeUrl);
  const handleAddNew = () => history.push(addNewUrl);

  const handleSuccess = () => {
    onChange(state);
    history.push(closeUrl);
  };

  return (
    <AdminModal
      title={`Change ${name}`}
      direction="top"
      className="change-modal"
      testId={`${name}-change-modal`}
      onClose={handleClose}
      onSuccess={handleSuccess}
      successBtn={<Button variant="primary" className="change-modal__btn">Save</Button>}
      extraButtons={[
        <Button variant="simple" className="change-modal__btn change-modal__btn_add" onClick={handleAddNew}>
          Add new
        </Button>,
      ]}
    >
      <div className="change-modal__content">
        {description && <p className="change-modal__description">{description}</p>}
        <ItemWrapper label={name}>
          <Select
            fieldProps={{
              ...fieldProps,
              value: state,
              onChange: handleChange,
            }}
            options={options}
            fetchOptions={fetchOptions}
          />
        </ItemWrapper>
      </div>
    </AdminModal>
  );
};

const Card = ({
                match,
                getTitle,
                subTitle,
                emptyStateSubTitle,
                cardName = '',
                fieldProps: { onChange, value, name, ...fieldProps },
                entities = [],
                changeModeDescription,
                Body,
                helperVariant,
                fetchEntities,
              }) => {
  const getActionTitle = (action) => `${action} ${cardName}`;
  const getActionUrl = (action) => pathToUrl(match.path, { ...match.params }) + name + '/' + action;

  const menuItems = [
    [
      {
        type: ActionBtnType.LINK,
        title: getActionTitle('Edit'),
        icon: <EditAssigmentSVG />,
        path: getActionUrl('update/1'),
      },
      {
        type: ActionBtnType.LINK,
        title: getActionTitle('Change'),
        icon: <ChangeSVG />,
        path: getActionUrl('change'),
      },
      {
        type: ActionBtnType.LINK,
        title: getActionTitle('Add'),
        icon: <PlusSmallSVG />,
        path: getActionUrl('create'),
      },
    ],
  ];

  const options = useMemo(() => formatDataForSelect(entities), [entities]);

  const handleChange = (option) => {
    const currentEntity = entities.find(({ id }) => +id === +option.id) || null;

    onChange(currentEntity);
  };

  return (
    <>
      <div
        className={cn('card-field', {
          'card-field_empty': !value,
          'card-field_error': helperVariant === 'error',
        })}
        data-testid="card-field"
      >
        <div className="card-field__header">
          <h4 className="card-field__title">{getTitle(value)}</h4>
          <p className="card-field__sub-title">
            {value ? subTitle : emptyStateSubTitle}
          </p>
          {value && (
            <ActionDropdown
              menuItems={menuItems}
              className="card-field__actions"
            />
          )}
        </div>
        {
          value
            ? (
              <div className="card-field__body">
                <Body entity={value} />
              </div>
            )
            : (
              <div className="card-field__empty" data-testid="empty-card">
                <Link to={getActionUrl('change')}>
                  <Button
                    variant="simple"
                    className="card-field__btn card-field__btn_set"
                    dataTestId={`${cardName}-set-btn`}
                  >
                    {getActionTitle('Set')}
                  </Button>
                </Link>
                <Link to={getActionUrl('create')}>
                  <Button
                    variant="simple"
                    className="card-field__btn card-field__btn_add"
                    dataTestId={`${cardName}-add-btn`}
                  >
                    <span>Add new</span>
                    <PlusSVG />
                  </Button>
                </Link>
              </div>
            )
        }
      </div>
      <AppSwitch>
        <Route
          path={`${match.path}${name}/change`}
          render={(props) => (
            <ChangeEntity
              name={cardName}
              fieldProps={{
                value: value ? {
                  id: value.id,
                  label: value.title,
                  value: value.title,
                } : null,
                name,
                onChange: handleChange,
                ...fieldProps
              }}
              description={changeModeDescription}
              options={options}
              fetchOptions={fetchEntities}
              closeUrl={pathToUrl(match.path, { ...match.params })}
              addNewUrl={getActionUrl('create')}
              {...props}
            />
          )}
        />
        <Route path={match.path} exact />
        <Route path={`${match.path}:entity/:action/:entityId?`} exact />
      </AppSwitch>
    </>
  );
};

export default withRouter(Card);
